export const livescoreItemTemplate = (
        livescoreItemOptionalClasses, livescoreMatchId, livescoreMatchUrl,
        teamHome, teamHomeImgUrl, teamGuest, teamGuestImgUrl,
        statusInfo,
        hasLivestream,
        lastVideoTemplatePRR) => `        
<div class="livescore-item" data-id="${livescoreMatchId}">
    <a class="match-info ${livescoreItemOptionalClasses}" href="${livescoreMatchUrl}">
        <div class="team-home"><img src="${teamHomeImgUrl}" width="40" alt="${teamHome}" title="${teamHome}"></div>
        <div class="team-guest"><img src="${teamGuestImgUrl}" width="40" alt="${teamGuest}" title="${teamGuest}"></div>
        <div class="status-row">
            ${statusInfo}
        </div>
        ${hasLivestream ? '<div class="livestream-label"><span>Livestream</span></div>' : ''}
    </a>
    ${lastVideoTemplatePRR}
</div>
`